import request from "@/util/axios.js"




// 一级部门获取
export const deptment = (data) => request("/projectFollow/deptment.json", data, 'post', false)
// 二级部门获取
export const secdeptment = (data) => request("/projectFollow/secdeptment.json", data, 'post', false)
// 获取下属
export const deptmentPeople = (data) => request("/projectFollow/deptmentPeople.json", data, 'post', false)
// 饼图
export const listPicture = (data) => request("/projectFollow/listPicture.json", data, 'post', false)


// 项目跟进详情列表
export const projectFollowList = (data) => request("/projectFollow/projectFollowList.json", data, 'post', false)

// 外部客户下拉框
export const foreign = (data) => request("/projectFollow/foreign.json", data, 'post', false)

// 项目对接统计
export const performance = (data) => request("/project/performance.json", data, 'post', false)

// 实地对接或者云对接统计
export const yunList = (data) => request("/project/yunList.json", data, 'post', false)

// 异地对接统计表 
export const remoteList = (data) => request("/project/remoteList.json", data, 'post', false)

// 项目部绩效统计表 
export const performanceList = (data) => request("/project/performanceList.json", data, 'post', false)

// 首次云对接绩效统计表 
export const reissueList = (data) => request("/project/reissueList.json", data, 'post', false)

// 项目落地绩效统计表 
export const landList = (data) => request("/project/landList.json", data, 'post', false)